export let AppConfig = {
    apiUrl: "https://devops-api.sac-stg.org"
}
